import { VISIBILITY_OPTIONS } from '~/utils/entry/isVisible';

export async function useRestrictedProtectedSlugs() {
  let protectedSlugs: string[] = [];
  let restrictedSlugs: string[] = [];
  const loaded = ref(false);

  if (!loaded.value) {
    const [pSlugs, rSlugs] = await Promise.all([
      (await $fetch('/api/contentful/slugs/protected', {
        method: 'GET'
      })) ?? [],
      (await $fetch('/api/contentful/slugs/restricted', {
        method: 'GET'
      })) ?? []
    ]);

    protectedSlugs = pSlugs;
    restrictedSlugs = rSlugs;
    loaded.value = true;
  }

  return (slug: string) => {
    if (protectedSlugs.includes(slug)) {
      return VISIBILITY_OPTIONS.loggedIn;
    }
    if (restrictedSlugs.includes(slug)) {
      return VISIBILITY_OPTIONS.restricted;
    }

    return VISIBILITY_OPTIONS.public;
  };
}
